<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="商户代码">
                    <c-input name="saas_id" maxlength="10"></c-input>
                </m-search-item>
                <m-search-item label="商户名称">
                    <c-input name="saas_full_name" maxlength="50"></c-input>
                </m-search-item>
                <m-search-item label="电子货架">
                    <c-input name="electronic_shelf_number" maxlength="50"></c-input>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_electronic_shelf_edit')" prepend-icon="tf-add" @click="$refs.saasShelfEdit.open()">
                    添加商户电子货架
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="商户代码"
                        name="saas_id"
                        width="65"
                        fixed="left"
                >
                </c-table-column>

                <c-table-column
                        label="商户名称"
                        name="saas_full_name"
                        width="180"
                        fixed="left"
                >
                </c-table-column>

                <c-table-column
                        label="货架编码"
                        name="electronic_shelf_number"
                        width="450"
                >
                </c-table-column>

                <c-table-column
                        label="商户类型"
                        name="merchant_type"
                        width="95"
                >
                    <template #default="{data}">
                        <span v-if="data.member_type == 2" style="color:blue">普通商户</span>
                        <span v-else style="color: green">自营商户</span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="155"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_electronic_shelf_edit')" icon="tf-edit" @click="$refs.saasShelfEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_electronic_shelf_edit')" icon="tf-trash" color="red" @click="removeSaasShelf(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--编辑商户电子货架弹窗-->
            <saas-shelf-edit ref="saasShelfEdit" @resolve="$refs.list.update()"></saas-shelf-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import saasShelfEdit from "@/pages/saas/saas_shelf_edit.vue.vue";

export default {
    components: {
        saasShelfEdit
    },
    computed: {
        ...mapState(['saasTypeDic', 'vipDic', 'disableEnableDic', 'salesStateDic', 'dateRangDic', 'registerSourceDic'])
    },
    props: {
        type: String
    },

    data() {
        return {
            versionOptions: []//可选版本列表
        }
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        /********搜索************/
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            data.has_electronic_shelf = 1;
            this.$refs.list.load({
                url: '/sys_saas/list',
                data
            });
        },
        /******删除商户电子货架***********/
        removeSaasShelf(data) {
            this.$confirm({
                message: '确认删除商户【' + data.saas_id + '/ '+ data.saas_name +'】的电子货架配置？删除后不可恢复，请谨慎操作',  // 提示内容,
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/sys_saas/edit/shelf_number',
                        data: {
                            saas_id: data.saas_id
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>